import type React from 'react';
import { Currency, CURRENCY_TRANSLATED } from '@enmon/commons/lib/enmon';
import { Select, type SelectProps } from 'antd';
import type { DefaultOptionType } from 'antd/lib/select';
import type { StrictOmit } from '@enmon/commons';
import { filterOption, filterSort } from '../utils';

export const getCountryOptions = (currencies?: readonly Currency[]) =>
  (currencies ?? Object.values(Currency)).map<DefaultOptionType>(currency => ({
    value: currency,
    label: CURRENCY_TRANSLATED[currency],
  }));

export interface CurrencySelectProps extends StrictOmit<SelectProps<number>, 'options'> {
  onChange?: (value: number | null) => void;
  options?: readonly Currency[];
}

export const CurrencySelect: React.VFC<CurrencySelectProps> = ({ onChange, options, ...propsToPass }) => {
  return (
    <Select
      filterOption={filterOption}
      filterSort={filterSort}
      options={getCountryOptions(options)}
      onSelect={(id?: number) => onChange?.(id)}
      {...propsToPass}
    />
  );
};
